import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setPendingConfirmation } from 'slices/serviceOrder'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import { ConfirmScheduleError, ConfirmScheduleInfo, ConfirmScheduleSuccess } from './components'
import { STAGES } from './constants'

export function ConfirmServiceScheduleDrawer() {
  const { stage, key } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  useEffect(() => {
    if (key === DRAWER_KEY.NONE) {
      dispatch(setPendingConfirmation(null))
    }
  }, [key, dispatch])

  function onClose() {
    dispatch(setPendingConfirmation(null))
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return stages({ onClose })[stage]

  function stages({ ...props }) {
    return {
      [STAGES.INITIAL]: <ConfirmScheduleInfo {...props} />,
      [STAGES.SUCCESS]: <ConfirmScheduleSuccess {...props} />,
      [STAGES.ERROR]: <ConfirmScheduleError {...props} />,
    }
  }
}
